'use strict';

import React, { PropTypes } from 'react';
import PageControls from '../molecules/PageControls';
import ShareAddStamp from '../organisms/ShareAddStamp';
import LikeButton from '../molecules/LikeButton';
import createStoreMixin from '../mixins/createStoreMixin';
import ClassNameMixin from '../mixins/ClassNameMixin';
import StampStore from '../stores/StampStore';
import createAnalyticsContextMixin from '../mixins/createAnalyticsContextMixin';
import AnalyticsSources from '../constants/AnalyticsSources';
import PureRenderMixin from '../mixins/PureRenderMixin';
import StampStatus from '../constants/StampStatus';
import Button from '../atoms/Button';
import UserStore from '../stores/UserStore';
import SidebarActionCreators from '../actions/SidebarActionCreators';
import SidebarTypes from '../constants/SidebarTypes';

const StampPageControls = React.createClass({
  mixins: [
    ClassNameMixin,
    createStoreMixin(StampStore, UserStore),
    PureRenderMixin,
    createAnalyticsContextMixin(AnalyticsSources.STAMP_PAGE_CONTROLS)
  ],

  propTypes: {
    stampId: PropTypes.number.isRequired
  },

  getStateFromStores(props) {
    const stamp = StampStore.get(props.stampId);
    const isAuthor = UserStore.isMe(stamp.user);
    return { stamp, isAuthor };
  },

  componentWillReceiveProps(newProps) {
    if (newProps.stampId !== this.props.stampId) {
      this.setState(this.getStateFromStores(newProps));
    }
  },

  render() {
    const { stamp, isAuthor } = this.state;
    const isUnlisted = stamp.status === StampStatus.UNLISTED;

    return (
      <PageControls>
        {stamp &&
          <PageControls.Container>
            <LikeButton stamp={stamp}
                        showCounter
                        context='PageControls'
                        color='black'
                        overlay
                        size='large' />
          </PageControls.Container>
        }
        {stamp &&
          <PageControls.Container>
            <ShareAddStamp size='large'
                           color='black'
                           overlay
                           context='PageControls'
                           stamp={stamp}
                           split />
          </PageControls.Container>
        }
      </PageControls>
    );
  }
});

export default StampPageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/StampPageControls.jsx
 **/